import moment from 'moment'


export const Moment = (data) => moment(data).format('DD-MMM-YYYY HH:mm:ss');
